module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAShJREFUOE9jZKASYKSSOQxDxKCZkVIi6cufvcHmbVxyKF6bHiGhwM7EpP+fkVmFifH/n4dPnkxtOMDwB2RggwMDi7yMTDaI/f/fvwc///27mLnixQOYZSgGzY6RcWBmYNzP8P//iX+M/1uY/v6TTFr+fA5I8bxIyZR/zEzPmf4z1jAwMlr8ZfjvmLrkyQH8BoFs/f//DwMD4xRGhn9gL/5nYBJhYPifw8jIyALiE20QoWQxUg2aGyllw8jMfJhQ+IAD/+9f2+Tlz45gjTVQWpGVko5hZGKMZ2BgdMBu4P8D///9X/j42dMlsDQGUoczr82MlNJgYWJOZ2D4nwIxkHHOn39/Z6Yvf3YDmwUEM+2cGFEVkMaUJa/v4PMyQYOICS+8XiPWAJg6AM+qgxMtWDlNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SearchPage/edition.png
// module id = frpx
// module chunks = 1